import { useEffect, useRef } from 'react'
import { CWComponents } from '@channelwill/components'
import { getShopifyIdToken } from '../../../../cw_center/getToken'
import { store } from '../../../../redux/store';

export const CWComponentsProvider = () => {

    // 是否初始化
    const initStateRef = useRef(false);
    const initLanguage = useRef('');

    // 语言对比
    const langCompare = {
        'cs': 'cs',
        'da': 'da',
        'ge': 'de',
        'en': 'en',
        'sp': 'es',
        'fr': 'fr',
        'it': 'it',
        'dut': 'nl',
        'nb': 'nb',
        'pl': 'pl',
        'pt_BR': 'pt-BR',
        'pt': 'pt-PT',
        'fi': 'fi',
        'sv': 'sv',
        'tr': 'tr',
        'th': 'th',
        'ja': 'ja',
        'zh_hant': 'zh-TW',
        'zh': 'zh-CN',
        'ko': 'ko',
    }

    // 初始化中台组件
    const CWComponentsInit = (shopInfo = {}) => {
        if (!shopInfo?.name || (initStateRef.current && initLanguage.current === shopInfo.language)) return

        initLanguage.current = shopInfo.language;
        CWComponents.init({
            baseUrl: process.env.PUBLIC_CHANNELWILL_DSN,
            componentMaps: {},
            appId: '518111167165693952',
            lang: langCompare[shopInfo.language],
            shopifyDomain: shopInfo.name
        })
        // 新增方法
        CWComponents.setShopifyIdToken(getShopifyIdToken)
    }

    useEffect(() => {
        store.subscribe(() => {
            const state = store.getState().public.publicInit;
            const shopInfo = state.shop_data;
            if (shopInfo && window.shopify) {
                CWComponentsInit(shopInfo);
                initStateRef.current = true;
            }
        })
    }, [])

    return null
}
